
export default class AudioFileBaseModel {
    private _audioFile: File = null;
    get audioFile(): File {
        return this._audioFile;
    }
    base64File: string;
    set audioFile(file: File) {
        this._audioFile = file;
        if (file == null) {
            this.base64File = null;
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            this.base64File = reader.result.toString();
        }
        reader.readAsDataURL(file);
    }
    _audioUrl: string = '';
    get audioUrl(): string | Blob {
        if (this.audioFile) {
            var blob = window.URL || window.webkitURL;
            return blob.createObjectURL(this.audioFile);
        }
        return this._audioUrl;
    }
    set audioUrl(value: string | Blob) {
        this._audioUrl = (value || '').toString();
    }
}
